/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fddf78ce673fc3115664c30833015a8121508a02";
